import css from './LineupModal.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Modal from 'components/Layout/Modal'
import Img from 'components/Media/Img'
import { useCurrentLanguage } from 'hooks/useCurrentLanguage'
import { useEventBulkData } from 'hooks/useEvent'
import { usePerformerBulkDetails } from 'hooks/usePerformer'

import MultiEvent from './MultiEvent'
import SingleEvent from './SingleEvent'

interface Props {
  setShowLineupModal: (show: boolean) => void
  eventCodes: string[]
  performerCodes: string[]
}

const LineupModal: React.FC<Props> = (props) => {
  const { setShowLineupModal, eventCodes, performerCodes } = props

  const { t } = useTranslation()

  const language = useCurrentLanguage()
  const performerData = usePerformerBulkDetails({ codes: performerCodes, language })
  const eventData = useEventBulkData({ idsOrCodeUrls: eventCodes })

  const isMultiEvent = eventCodes.length > 1

  if (!performerData || performerData.length != performerCodes.length || !eventData || eventData.length < 1) {
    return null
  }

  if (isMultiEvent && (!eventData || eventData.length != eventCodes.length)) {
    return null
  }

  return (
    <Modal
      closeIconPath="/icons/close_icon_white_smallcross.svg"
      transparent
      noBodyFixed
      show
      hideCloseIcon
      fullWidth
      disableScroll
      overflowY
      handleClose={() => setShowLineupModal(false)}
    >
      <div className={css.lineupModalContainer}>
        <div className={css.header}>
          <h3 className={css.title}>{t('collection:artist_title')}</h3>
          <div
            className={css.closeIcon}
            onClick={() => {
              setShowLineupModal(false)
            }}
          >
            <Img src="/icons/close_icon_white_smallcross.svg" />
          </div>
        </div>
        <div className={css.content}>
          {!isMultiEvent && eventData && eventData[0] && (
            <SingleEvent
              list={performerData.map((el) => {
                return {
                  role: eventData[0].lineup?.find((x) => x.code == el.code)?.role,
                  code: el.code,
                  name: el.name,
                  imageUrl: el.assets?.find((x) => x.format == 'SQUARE')?.url ?? '',
                }
              })}
            />
          )}

          {isMultiEvent && eventData && (
            <div className={css.multiEventContainer}>
              {eventData.map((event, key) => {
                const eventPerformersData = performerData.filter((p) => event.lineup?.find((x) => x.code === p.code))

                return (
                  <MultiEvent
                    key={key}
                    eventData={event}
                    list={eventPerformersData.map((el) => {
                      return {
                        role: event.lineup?.find((x) => x.code == el.code)?.role,
                        time: event.lineup?.find((x) => x.code == el.code)?.time,
                        code: el.code,
                        name: el.name,
                        imageUrl: el.assets?.find((x) => x.format == 'SQUARE')?.url ?? '',
                      }
                    })}
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default LineupModal
